import { Component, Input, OnChanges } from '@angular/core';
import getScoreTypeDetails from 'src/app/shared/utils/score-type-details';

@Component({
  selector: 'app-chat-charts-trend',
  templateUrl: './chat-charts-trend.component.html',
  styleUrls: ['./chat-charts-trend.component.scss'],
})
export class ChatChartsTrendComponent implements OnChanges {
  @Input() childTrend: string;
  @Input() childTrendScore: string;
  @Input() childTrendTimeframe: string;

  score: string | null;
  companyName: string;
  timeframe: string;

  ngOnChanges(): void {
    this.companyName = this.childTrend;
    this.score = getScoreTypeDetails(this.childTrendScore).scoreKey;
    this.timeframe = this.childTrendTimeframe;
  }
}
